import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/Dashboard';
import { useAuthValidation } from '../../utils/hooks';

const DashboardPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default DashboardPage;
